/**
 * MainLayout Component
 * Main application layout with header, content area, and sidebar.
 */
import React from 'react';
import Header from './Header';

interface MainLayoutProps {
  filename?: string;
  onNewDocument?: () => void;
  children: React.ReactNode;
  sidebar?: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({
  filename,
  onNewDocument,
  children,
  sidebar,
}) => {
  return (
    <div className="h-screen flex flex-col bg-gray-100">
      <Header filename={filename} onNewDocument={onNewDocument} />

      <div className="flex-1 flex overflow-hidden">
        {/* Main content */}
        <main className="flex-1 overflow-hidden">{children}</main>

        {/* Sidebar */}
        {sidebar}
      </div>
    </div>
  );
};

export default MainLayout;
